import { ArrowUUpLeft, CheckCircle, Clock, DeviceMobile, XCircle } from '@phosphor-icons/react';
import type { OrderStatus } from '../../api/orderApi';
import { ORDER_STATUS_LABEL } from '../../lib/orderStatus';
import styles from './OrderStatusBadge.module.css';

const ICONS = {
  PENDING: Clock,
  PAID: Clock,
  AWAITING_SMS: DeviceMobile,
  COMPLETED: CheckCircle,
  REFUNDED: ArrowUUpLeft,
  FAILED: XCircle,
} as const;

export function OrderStatusBadge({ status }: { status: OrderStatus }) {
  const Icon = ICONS[status];
  return (
    <span className={`${styles.badge} ${styles[status]}`}>
      <Icon size={15} weight="fill" aria-hidden />
      {ORDER_STATUS_LABEL[status]}
    </span>
  );
}
